module.exports = __webpack_public_path__ + "img/receivebox_mint2.bc7b7706.png";